import React from "react";
import { ProductItemInterface } from "@/assets/interfaces";
import { enumToHumanFriendly } from "@/assets/js/utils/utils";
import { getVariantTypesAndCounts } from "@/assets/js/utils/product-options";

interface ProductOptionsProps {
  item: ProductItemInterface;
  onSelectOptions: () => void;
}

const ProductOptions = ({ item, onSelectOptions }: ProductOptionsProps) => {
  if (!item?.variants?.options.length) return null;

  const variantCounts = getVariantTypesAndCounts(item?.variants);

  return (
    <div>
      <div className="flex items-center justify-between mb-3.5">
        <h5 className="text-black font-display font-bold text-sm md:text-1sm max-w-full whitespace-nowrap overflow-ellipsis">
          Options
        </h5>
        <button
          className="no-outline text-primary-500 flex items-center text-1xs font-semibold"
          onClick={onSelectOptions}
        >
          <span className="">See Options</span>
          {/* prettier-ignore */}
          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" className="ml-0.75">
            <path d="M1 7L7 1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}/>
            <path d="M1 1H7V7" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2}/>
          </svg>
        </button>
      </div>
      <div className="w-full bg-grey-fields-100 rounded-10">
        {Object.entries(variantCounts).map(([key, value]) => (
          <div
            key={key}
            className="flex items-center justify-between py-2.5 px-4 text-sm border-b border-grey-border border-opacity-50 last:border-b-0"
          >
            <div className="text-dark flex items-center">
              {/* prettier-ignore */}
              <svg width="14" viewBox="0 0 12 12" fill="none" className="mr-1.5">
                <path d="M5 1.5H1.5V5H5V1.5Z" stroke="#737576" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M10.5001 1.5H7.00009V5H10.5001V1.5Z" stroke="#737576" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M10.5001 7H7.00009V10.5H10.5001V7Z" stroke="#737576" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M5 7H1.5V10.5H5V7Z" stroke="#737576" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {enumToHumanFriendly(key)}
            </div>
            <div className="text-black-secondary font-medium">{value} Options</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductOptions;
